import React from 'react';
import Link from 'next/link';
import styles from '../../styles/rca/rca.module.scss';

const RCALegalNotice = () => {

    return (
        <div className={`${styles.boxWrapper} mb-5 text-start`} >
            <p className={`${styles.boxCategory}`}>
                Termeni legali
            </p>
            <p className={styles.info}>
                Asigurarile RCA cumparate online pe Conso sunt emise in numele societatilor de asigurare de catre CMG BROKER SRL societate cu raspundere limitata, cu sediul in Str. Dr. Nicolae Tomescu nr. 11, Ap. 1, Sector 5, cod postal: 050595, Bucuresti, inregistrata in Registrul Intermediarilor in Asigurari si/sau Reasigurari sub numarul  RAJ 550379, in calitate de asistent in brokeraj al CAMPION BROKER DE ASIGURARE SI REASIGURARE SRL – intermediar principal in asigurari, mandatat de catre societatile de asigurare, cu sediul in Ploiesti, str 1 Mai, nr.2, ap.2, judet Prahova, inscrisa in Registrul Brokerilor de Asigurare nr. RBK -324/24.11.2005, cu autorizatie de functionare nr. 3963/23.11.2005. Pentru mai multe detalii, citeste <Link
                href={`${process.env.NEXT_PUBLIC_WEB}/termeni/asigurari`}
                title="Termeni contracte de asigurare RCA"
                target="_blank">Termenii contractelor de asigurare RCA</Link>.    
            </p>
        </div>
    );
}

export default RCALegalNotice;